import classNames from "classnames";
import React from "react";
import { Icon } from "../../../components";
import styles from "./portal_booking_card.module.css";
import { PortalButton } from "./portal_button";

interface PortalBookingCardProps {
  imageUrl: string;
  date: string;
  time?: string;
  spaceName: string;
  spaceType: string;
  location: string;
  cancellable: boolean;
  isCancelled: boolean;
  numberOfAttendees?: number;
  onCancel: () => void;
  onInvite?: () => void;
}

export function PortalBookingCard({
  imageUrl,
  date,
  time,
  spaceName,
  spaceType,
  location,
  cancellable,
  isCancelled,
  numberOfAttendees,
  onInvite,
  onCancel,
}: PortalBookingCardProps) {
  const hasAttendees = numberOfAttendees && numberOfAttendees > 0;
  const hasButtons = onInvite || cancellable;

  return (
    <div
      className={classNames(styles.component, isCancelled && styles.isCanceled)}
    >
      <img className={styles.image} src={imageUrl} alt={spaceName} />
      <div className={styles.detailsWrapper}>
        <div>
          {isCancelled && <div className={styles.cancelledChip}>CANCELLED</div>}
          <div className={styles.date}>
            {date}{" "}
            {time && (
              <>
                <Icon name="dot" size={6} color="#000" /> {time}
              </>
            )}
          </div>
          <div className={styles.spaceName}>
            {spaceName} <Icon name="dot" size={6} color="#000" /> {spaceType}
          </div>
          <div>
            Location: <span className={styles.location}>{location}</span>
          </div>
          {hasAttendees && !isCancelled && (
            <div>
              Invitation sent to 5 attendees (
              <button className={styles.button}>view</button>)
            </div>
          )}
        </div>
        {hasButtons && !isCancelled && (
          <div className={styles.buttonWrapper}>
            {onInvite && (
              <PortalButton onClick={onInvite}>Invite attendees</PortalButton>
            )}
            {cancellable && (
              <button className={styles.button} onClick={onCancel}>
                Cancel
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
